module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activate-company account-suspended"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "activate-company__hero"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-do-not-enter",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "do-not-enter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM415.9 304H96.05C87.21 304 79.95 296.9 79.95 288V224c0-8.875 7.266-16 16.11-16h319.9c8.84 0 16.11 7.125 16.11 16v64C432.1 296.9 424.8 304 415.9 304z"
    }
  })]), _vm._v("\n          Your account is suspended.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          We can't take you to your dashboard because your organisation subscription expired on " + _vm._s(_vm.expiryDate) + ". To resume your work with ClearAssured, please renew your subscription or get in touch with your designated billing contact:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data"
  }, [_c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing contact:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingContact))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing email:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingEmail))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "activate-company__billing-data--label"
  }, [_vm._v("Billing phone:")]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__billing-data--value"
  }, [_vm._v(_vm._s(_vm.billingPhone))])])]), _vm._v(" "), (_vm.canRenew) ? _c('router-link', {
    staticClass: "activate-company__billing-renew",
    attrs: {
      "to": {
        name: 'billing-profile'
      }
    }
  }, [_vm._v("\n          Renew subscription\n        ")]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f61690e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/AccountSuspended.vue
// module id = 1063
// module chunks = 0